// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1aUrW","ranges":"BmiRanges_ranges__20mNX"};